import { createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, withKeys as _withKeys, createBlock as _createBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/light-magnifying-glass.svg'


const _withScopeId = n => (_pushScopeId("data-v-2f94452d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "line-search-container" }
const _hoisted_2 = {
  ref: "searchResultContainer",
  class: "search-result-container"
}
const _hoisted_3 = {
  key: 0,
  class: "no-search-initial"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "search-icon",
  src: _imports_0,
  "aria-hidden": "true",
  alt: ""
}, null, -1 /* HOISTED */))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "subtitle" }, [
  /*#__PURE__*/_createTextVNode(" 검색어 입력 또는 필터 적용 후"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("strong", { class: "emphasis" }, "검색 버튼"),
  /*#__PURE__*/_createTextVNode("을 눌러주세요. ")
], -1 /* HOISTED */))
const _hoisted_6 = { key: 1 }
const _hoisted_7 = ["onClick", "onKeydown"]
const _hoisted_8 = {
  key: 2,
  class: "no-search-result"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "검색결과가 없습니다.", -1 /* HOISTED */))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "content" }, " 검색어를 다시 확인하시거나 필터를 수정해 보세요. ", -1 /* HOISTED */))
const _hoisted_11 = { class: "line-path-btn-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Page"], null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode($setup["NavigationBar"], {
          class: "navigation-bar",
          title: "노선검색",
          isUnderline: false
        }),
        _createVNode($setup["SearchInput"], {
          class: "search-input",
          name: "searchInput",
          locationSearch: true,
          value: $setup.searchKeyword,
          showSearchButton: true,
          searchButtonDisabled: $setup.isSearching,
          "onUpdate:value": $setup.updatedSearchKeyword,
          onOnEnter: $setup.handleSearch,
          onOnClickSearchButton: $setup.handleSearch
        }, null, 8 /* PROPS */, ["value", "searchButtonDisabled"]),
        _createVNode($setup["LineSearchFilterSummary"], {
          searchParamsMap: $setup.searchParamsMap,
          bookRequiredType: $setup.bookRequiredType,
          onOnClickFilter: _cache[0] || (_cache[0] = ($event: any) => ($setup.toggleShowLineFilter(true))),
          onOnClickDeleteFilter: $setup.deleteFilter
        }, null, 8 /* PROPS */, ["searchParamsMap", "bookRequiredType"]),
        _createElementVNode("div", _hoisted_2, [
          (!$setup.hasSearched)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _hoisted_4,
                _createCommentVNode(" <p class=\"title\">찾으시는 버스 노선을 검색해 보세요.</p> "),
                _hoisted_5
              ]))
            : ($setup.searchedLineInfos.length)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.searchedLineInfos, (lineInfo) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: lineInfo.id,
                      onClick: () => $setup.onSelectLine(lineInfo),
                      onKeydown: _withKeys(_withModifiers(() => $setup.onSelectLine(lineInfo), ["prevent"]), ["enter"])
                    }, [
                      _createVNode($setup["LineInfoRow"], {
                        lineInfo: lineInfo,
                        checkedLineIds: $setup.checkedLineIds,
                        shouldShowCheckBox: $setup.maxCheckedLinesCount > 0,
                        isPossibleToCheckLine: $setup.isPossibleToCheckLine,
                        onOnChangedCheck: $setup.handleCheckLineInfoRow
                      }, null, 8 /* PROPS */, ["lineInfo", "checkedLineIds", "shouldShowCheckBox", "isPossibleToCheckLine", "onOnChangedCheck"])
                    ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_7))
                  }), 128 /* KEYED_FRAGMENT */))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _hoisted_9,
                  _hoisted_10,
                  _createCommentVNode(" <button\n              class=\"go-to-new-line-btn\"\n              @click=\"goToNewRouteApplicationList\"\n            >\n              신규 노선/정류장 신청\n            </button> ")
                ]))
        ], 512 /* NEED_PATCH */),
        ($setup.searchResultContainer)
          ? (_openBlock(), _createBlock($setup["ScrollTopControl"], {
              key: 0,
              container: $setup.searchResultContainer
            }, null, 8 /* PROPS */, ["container"]))
          : _createCommentVNode("v-if", true)
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_11, [
        _createElementVNode("button", {
          type: "button",
          onClick: $setup.handleClickShowLineTurnPathMapButton
        }, _toDisplayString($setup.pathMapBtnTitle), 1 /* TEXT */)
      ], 512 /* NEED_PATCH */), [
        [_vShow, $setup.isPossibleToShowLinePath]
      ]),
      _withDirectives(_createVNode($setup["PageModal"], {
        shouldShow: $setup.shouldShowLineFilter,
        useVShow: true,
        onBackHandler: () => $setup.toggleShowLineFilter(false)
      }, {
        default: _withCtx(() => [
          _createVNode($setup["LineSearchFilter"], {
            ref: "lineSearchFilter",
            class: "search-filter",
            bookRequiredType: $setup.bookRequiredType,
            appliedSearchParamsMap: $setup.searchParamsMap,
            onOnClickApplyBtn: $setup.searchLine,
            onOnDeletedFilter: $setup.searchLine,
            onOnClickClose: _cache[1] || (_cache[1] = ($event: any) => ($setup.toggleShowLineFilter(false))),
            onOnFiltersValidated: $setup.handleFiltersValidated
          }, null, 8 /* PROPS */, ["bookRequiredType", "appliedSearchParamsMap"])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["shouldShow", "onBackHandler"]), [
        [_vShow, $setup.shouldShowLineFilter]
      ]),
      _createVNode($setup["PageModal"], {
        shouldShow: $setup.shouldShowMultipleLineTurnPathMap,
        onBackHandler: () => $setup.toggleShowMultipleLineTurnPathMap(false)
      }, {
        default: _withCtx(() => [
          _createVNode($setup["MultipleLineTurnPathMap"], {
            lineInfos: $setup.lineInfosResult?.data,
            linePathColorInfos: $setup.linePathColorInfos,
            onOnClickClose: _cache[2] || (_cache[2] = ($event: any) => ($setup.toggleShowMultipleLineTurnPathMap(false)))
          }, null, 8 /* PROPS */, ["lineInfos", "linePathColorInfos"])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["shouldShow", "onBackHandler"])
    ]),
    _: 1 /* STABLE */
  }))
}